import { ChatStore } from "@/stores/ChatStore";
import "./status-message.css";
import { useTranslation } from "react-i18next";

export default function StatusMessage() {
  const { t } = useTranslation();
  const avatarStatus = ChatStore(state => state.avatarStatus);

  if (!avatarStatus) {
    return null;
  }

  return (
    <div className="flex h-14 items-center rounded-full bg-white px-4 py-2 shadow-lg">
      <div className="relative h-6 w-6 overflow-hidden">
        <div className="absolute inset-0 flex items-end justify-around">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="w-1 rounded-full bg-primary opacity-80"
              style={{
                animation: `barHeight${(i % 3) + 1} 1s ease-in-out infinite`,
                animationDelay: `${i * 0.1}s`,
              }}
            />
          ))}
        </div>
      </div>
      {avatarStatus && <p className="ml-4 font-semibold text-[#333333]">{t(`avatarStatus.${avatarStatus.toLowerCase()}`)||avatarStatus}</p>}
    </div>
  );
}
